
import { defineComponent } from 'vue';
import { ChevronLeft, ChevronRight } from '@vicons/fa';
import Missions from '@/components/Missions.vue';
import Live from '@/components/Live.vue';
import Upcoming from '@/components/Upcoming.vue';
import Links from '@/components/Links.vue';

export default defineComponent({
  name: 'Racing',
  components: { Missions, Live, Upcoming, Links, ChevronLeft, ChevronRight }
});
